
<template>
    <el-card
        style="
            width: 100%;
            margin-top: 0px;
            padding-top: 0px;
            height: 890px;

            background-image: url(/static/img/地理调查表背景.png);
        "
    >
        <el-card
            style="
                width: 1680px;
                height: 840px;
                margin: 0 auto;
                margin-top: 30px;
            "
        >
            <div
                style="
                    width: 100%;
                    line-height: 30px;
                    margin-top: 30px;
                    margin-left:30px
                    text-align: left;
                    height: 890px;
                "
            >
                <!-- 标题 -->
                <div style="text-align: left">
                    <span
                        class="title-l1"
                        style="
                            font-size: 28px;
                            color: #121212;
                            font-weight: 500;
                        "
                        >地理调查表</span
                    >
                </div>
                <div
                    style="
                        width: 30px;
                        height: 6px;
                        background: #12c287;
                        margin-top: 12px;
                    "
                ></div>
                <!-- 检索 -->
                <div>
                    <el-row>
                        <el-col
                            :span="2"
                            style="text-align: left; margin-top: 39px"
                        >
                            <span
                                style="
                                    font-size: 16px;
                                    line-height: 22px;
                                    font-weight: 400;
                                "
                            >
                                所在厅县：</span
                            >
                        </el-col>
                        <el-col
                            :span="3"
                            style="margin-top: 36px; margin-left: -50px"
                        >
                            <el-input
                                placeholder="请选择"
                                size="medium"
                                :disabled="true"
                                v-model="selcetCountry.label"
                            ></el-input>
                        </el-col>
                        <el-col
                            :span="1"
                            style="margin-left: 30px; margin-top: 34px"
                        >
                            <el-button
                                type="primary"
                                size="medium"
                                style="line-height: 18px"
                                @click="dialogTableVisible = true"
                                >选择</el-button
                            >
                        </el-col>
                        <el-col :offset="15" :span="3" style="margin-top: 34px">
                            <el-button
                                type="primary"
                                size="medium"
                                style="line-height: 18px"
                                @click="batchExportData"
                                >批量下载</el-button
                            >
                        </el-col>
                    </el-row>
                </div>
                <!-- 表格 -->
                <div>
                    <div
                        id="divTable"
                        class="main_table"
                        style="width: 99%; margin-top: 30px"
                    >
                        <el-table
                            class="main_table"
                            ref="multipleTable"
                            :row-key="rowKey"
                            :row-style="{ height: 0 + 'px' }"
                            :cell-style="{ padding: 0 + 'px' }"
                            :data="currentPageData"
                            @select="handleSelectionChange"
                            @select-all="handleSelectionAll"
                            :header-cell-style="{
                                background: '#eef1f6',
                                color: '#606266',
                            }"
                        >
                            <el-table-column
                                type="selection"
                                :selectable="selectable"
                                :reserve-selection="true"
                                width="50"
                            ></el-table-column>
                            <el-table-column
                                :index="indexMethod"
                                type="index"
                                label="序号"
                                width="80"
                            ></el-table-column>

                            <el-table-column
                                class="text-body"
                                label="聚落名称"
                                width="150"
                                prop="name"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="所在区县"
                                width="150"
                                prop="lev2_name"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="所在乡镇"
                                width="150"
                                prop="lev3"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="位置信息"
                                width="150"
                                prop="location"
                                :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="户数"
                                width="100"
                                prop="household"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="口数"
                                width="100"
                                prop="population"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="附录"
                                width="380"
                                prop="excursus"
                                :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                class="text-body"
                                label="普查人员"
                                prop="censusenum"
                                width="200"
                                :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column class="text-body" label="操作">
                                <template slot-scope="scope">
                                    <el-button
                                        type="primary"
                                        @click="exportRow(scope.row)"
                                        icon="el-icon-download"
                                        >下载</el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="pagination_fa_div" style="margin-left: 0px">
                        <el-pagination
                            background
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :page-count="pageCount"
                            :current-page.sync="currentPageIndex"
                            @current-change="handlePageTurn"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
            <!-- 县厅检索 -->
            <el-dialog
                width="20%"
                title="请选择聚落的所在厅县"
                :visible.sync="dialogTableVisible"
                style="text-align: left"
                class="dialog"
            >
                <comCountrySearch
                    @changeCountry="changeCountry"
                ></comCountrySearch>
            </el-dialog>
        </el-card>
    </el-card>
</template>

<script>
import comCountrySearch from '@/V3/Main/DataDownload/comCountrySearch.vue'
import axios from 'axios'
import table2excel from 'js-table2excel'
export default {
    data() {
        return {
            // 选择所在区县的弹出框 是否弹出
            dialogTableVisible: false,
            // 选择所在厅县 省
            selcetCountry: {
                label: '',
                level: 1,
            },
            // 分页插件配置
            // 总共有多少页
            pageCount: 0,
            // 当前数据
            currentPageData: [],
            // 全部数据
            allPageData: [],
            // 一页有多少条数据
            pageSize: 10,
            // 当前在多少页
            currentPageIndex: 1,

            // 数据过滤条件
            CQL_FILTER: null,

            // // 复选框选中的表格数据
            tableSelection: [],
            countyData:{}
        }
    },
    watch: {},
    components: {
        comCountrySearch,
    },

    mounted() {
        this.onloadCountyData()
        this.initCountryData(this.CQL_FILTER)
    },

    methods: {
        // 县 全表格
        onloadCountyData(){
            axios({
                    url: $webConfig.V3.backendAPI + 'getCountyDetailNew',
                    method: 'post',
                    data: JSON.stringify({
                       
                    }),
            }).then(res=>{
                this.countyData = res.data.data
            })
        },
        // 厅县选择发生变换
        changeCountry(data) {
            if (data.level == 1) {
                this.CQL_FILTER = null
                this.selcetCountry = ''
                this.initCountryData(this.CQL_FILTER)
            } else if (data.level == 2) {
                this.CQL_FILTER = null
                this.selcetCountry = ''

                this.initCountryData(this.CQL_FILTER)
            } else if (data.level == 3) {
                this.selcetCountry = data
                this.CQL_FILTER = 'lev2_name=' + "'" + data.label + "'"
                this.initCountryData(this.CQL_FILTER)
                // this.dialogTableVisible = false
            }
        },
        // 默认加载第一页 甘肃省的数据
        initCountryData(CQL_FILTER) {
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: url_params,
            }).then((res) => {
                // 计算总共多少页
                self.pageCount = Math.ceil(
                    res.data.totalFeatures / self.pageSize
                )
                let resultTable = []
                res.data.features.forEach((item) => {
                    // 过滤数据
                    resultTable.push(Object.assign(item.properties,self.countyData[item.properties.lev2]))
                })
                self.allPageData = resultTable
                // 给当前页赋值数据
                self.currentPageData = self.allPageData.slice(
                    (self.currentPageIndex - 1) * self.pageSize,
                    self.currentPageIndex * self.pageSize
                )
            })
        },
        // 翻页
        handlePageTurn(val) {
            this.currentPageIndex = val

            // 给当前页赋值数据
            this.currentPageData = this.allPageData.slice(
                (this.currentPageIndex - 1) * this.pageSize,
                this.currentPageIndex * this.pageSize
            )

        },

        indexMethod(index) {
            return (this.currentPageIndex - 1) * this.pageSize + index + 1
        },
        // 导出 一行记录
        exportRow(value) {
            // console.log(value)
             const column = [
                {
                    title: '聚落ID',
                    key: 'id',
                    type: 'text',
                },
                {
                    title: '聚落名称',
                    key: 'name',
                    type: 'text',
                },
                {
                    title: '所在区县',
                    key: 'lev2_name',
                    type: 'text',
                },
                {
                    title: '位置信息',
                    key: 'n_position',
                    type: 'text',
                },
                {
                    title: '户数',
                    key: 'household',
                    type: 'text',
                },
                {
                    title: '口数',
                    key: 'population',
                    type: 'text',
                },
                {
                    title: '附录',
                    key: 'excursus',
                    type: 'text',
                },
                {
                    title: '普查人员',
                    key: 'censusenum',
                    type: 'text',
                },
                        {
                    title: '是否现存调查表',
                    key: '是否现存调查表',
                    type: 'text',
                },
                        {
                    title: '明确注明的奏报日期',
                    key: '明确注明的奏报日期',
                    type: 'text',
                }, {
                    title: '调查表奏报者',
                    key: '调查表奏报者',
                    type: 'text',
                },
            ]
            /** column数据的说明 */
            // 1.title为列名
            // 2.key为data数据每个对象对应的key
            // 3.若为图片格式, 需要加type为image的说明,并且可以设置图片的宽高
            const excelName = value.name + '-' + value.lev2_name
            table2excel(column, [value], excelName)

        },
        // 多选
        handleSelectionChange(val, row) {
            // debugger
            this.tableSelection = val
            if (this.tableSelection.length == 20) {
                this.$message({
                    type: 'success',
                    message:
                        '已达到下载数量限制，请点击“批量下载”按钮进行下载。',
                })
            }
        },
        // 全选
        handleSelectionAll(val) {
            this.tableSelection = val
            if (this.tableSelection.length == 20) {
                this.$message({
                    type: 'success',
                    message:
                        '已达到下载数量限制，请点击“批量下载”按钮进行下载。',
                })
            }
        },
        // 表格选择记忆
        rowKey(row) {
            return row.id
        },
        // 限制选择的条数
        selectable(row) {
            let index = this.tableSelection.findIndex((v) => v.id === row.id)
            if (this.tableSelection.length >= 20) {
                if (index !== -1) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        // 批量导出
        batchExportData() {
            const column = [
                {
                    title: '聚落ID',
                    key: 'id',
                    type: 'text',
                },
                {
                    title: '聚落名称',
                    key: 'name',
                    type: 'text',
                },
                {
                    title: '所在区县',
                    key: 'lev2_name',
                    type: 'text',
                },
                {
                    title: '位置信息',
                    key: 'n_position',
                    type: 'text',
                },
                {
                    title: '户数',
                    key: 'household',
                    type: 'text',
                },
                {
                    title: '口数',
                    key: 'population',
                    type: 'text',
                },
                {
                    title: '附录',
                    key: 'excursus',
                    type: 'text',
                },
                {
                    title: '普查人员',
                    key: 'censusenum',
                    type: 'text',
                }, {
                    title: '是否现存调查表',
                    key: '是否现存调查表',
                    type: 'text',
                },
                        {
                    title: '明确注明的奏报日期',
                    key: '明确注明的奏报日期',
                    type: 'text',
                }, {
                    title: '调查表奏报者',
                    key: '调查表奏报者',
                    type: 'text',
                },
            ]
            /** column数据的说明 */
            // 1.title为列名
            // 2.key为data数据每个对象对应的key
            // 3.若为图片格式, 需要加type为image的说明,并且可以设置图片的宽高
            const excelName = 'test'
            if (this.tableSelection.length == 0) {
                this.tableSelection = this.currentPageData
                // 使之勾选
                this.tableSelection.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row)
                })
            }
            table2excel(
                column,
                this.tableSelection,
                this.tableSelection[0].name +
                    '-' +
                    this.tableSelection[0].lev2_name +
                    '等批量下载'
            )
        },
       
    },
}
</script>


<style scoped>
.box-card {
    margin-top: 0px;
}

.main_table >>> .el-table td {
    padding: 5px 0px !important;
}
.main_table >>> .el-table .cell {
    font-size: 16px;
    font-family: '微软雅黑';
}
.dialog >>> .el-dialog__header {
    background: #12c287 !important;
    padding: 20px 20px 20px !important;
}

.dialog >>> .el-dialog__title {
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 22px;
    font-weight: 500;
}
.dialog >>> .el-dialog__close {
    /* color: #12C287; */
    color: white !important;
}
.dialog >>> .dialog__headerbtn:hover .el-dialog__close {
    /* color: #12C287; */
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/V3/Main/comDataDownload.vue